module.exports = __webpack_public_path__ + "img/icon_5_96.2c497fbe.png";